import { SceneDTO } from 'client-generator/generated-clients/plants';
import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import { mapState } from 'vuex';

export enum SceneWizardStepEnum {
  STEP_ACTION,
  STEP_TRIGGER,
  STEP_CONDITION,
}

@Options({
  name: 'SceneWizardStep',
  props: {
    scene: {
      type: Object as PropType<SceneDTO>,
    },
  },
  computed: {
    ...mapState(['selectedPlantId']),
  },
  emits: ['next-enabled'],
})
export default class SceneWizardStep extends Vue {
  plantId = -1;
  scene!: SceneDTO;
  selectedPlantId!: number;
  SceneWizardStepEnum = SceneWizardStepEnum;

  created() {
    this.plantId = +this.$route.params.plantId;
  }

  get componentName() {
    return this.$options.name;
  }
}
